import { getSectorInfo } from '../meetstandaard/sectorCatalog'

// Bouwt de sectorknoppen boven het projectenoverzicht, met per knop het aantal
// tenants dat eronder valt.
//
// De lijst is de unie van twee bronnen, en dat is met opzet:
//   - `selectableSectors` (uit useAvailableSectors) → wat een tenant KAN kiezen,
//     zodat een sector die nog niemand heeft toch zichtbaar is, met telling 0.
//   - de sectoren die daadwerkelijk op tenants staan → zodat een sector die de
//     meetstandaard-api (nog) niet publiceert niet stilletjes uit het filter
//     verdwijnt en zijn tenants onvindbaar maakt.
//
// 'Alle sectoren' staat vooraan, 'Geen sector' achteraan; daartussen op label
// gesorteerd.
//
// Het veld heet `projectCount` en niet `count`: SelectableGrid rendert een veld
// met de naam `count` zelf al als los getal naast het label, waardoor de telling
// dubbel op het scherm zou staan.
//
// @param {Array<{SelectedSectors?: string[]}>} [projects] - CompagnyMeta-documenten
// @param {string[]} [selectableSectors] - sector-slugs uit useAvailableSectors
// @returns {Array<{value: string, label: string, projectCount: number}>}
const buildSectorTabs = (projects, selectableSectors) => {

    const list = Array.isArray(projects) ? projects : []
    const selectable = Array.isArray(selectableSectors) ? selectableSectors : []

    const projectCounts = new Map(selectable.filter(Boolean).map((slug) => [slug, 0]))
    let withoutSector = 0

    list.forEach((project) => {
        const sectors = Array.isArray(project?.SelectedSectors)
            ? project.SelectedSectors.filter(Boolean)
            : []

        if (sectors.length === 0) {
            withoutSector++
            return
        }

        sectors.forEach((slug) => projectCounts.set(slug, (projectCounts.get(slug) || 0) + 1))
    })

    const sectorTabs = [...projectCounts.entries()]
        .map(([slug, projectCount]) => ({ value: slug, label: getSectorInfo(slug).label, projectCount }))
        .sort((a, b) => a.label.localeCompare(b.label))

    return [
        { value: 'all', label: 'Alle sectoren', projectCount: list.length },
        ...sectorTabs,
        { value: 'none', label: 'Geen sector', projectCount: withoutSector },
    ]
}

export default buildSectorTabs
